import { Component, ViewChild, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { CouponType } from '../../app/models/CouponType';
import { AlertsHolder } from '../../app/models/AlertsHolder';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-coupon-types',
  templateUrl: 'coupon-types.html',
})
export class CouponTypesPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('couponModal')
  private couponModal: ModalDirective;

  @ViewChild('couponForm')
  private couponForm: NgForm;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  private pageName: string = 'page-coupon-types';
  private coupons: CouponType[] = [];
  currentCoupon = new CouponType();
  private alertsHolder: AlertsHolder;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private translate: TranslateService
  ) {
    this.alertsHolder = new AlertsHolder(translate);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getCoupons();
  }

  private getCoupons() {
    this.backendService.getCouponTypes().subscribe(
      (coupons) => {
        this.coupons = coupons;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addCoupon() {
    this.currentCoupon = new CouponType();
    this.couponForm.resetForm();
    this.showAddModal();
  }

  editCoupon(coupon: CouponType) {
    this.currentCoupon = coupon;
    this.showAddModal();
  }

  deleteCoupon() {
    this.backendService
      .deleteCouponType(this.currentCoupon)
      .subscribe(
        (data) => {
          this.getCoupons();
        },
        (err: HttpErrorResponse) => {
          this.alertsHolder.show(err.error.code, 'danger');
        }
      )
      .add(() => {
        this.closeConfirmModal();
      });
  }

  submitCoupon(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .saveOrUpdateCouponType(this.currentCoupon)
      .subscribe(
        (coupon) => {
          this.getCoupons();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        btnEvent.disabled = false;
        this.closeAddModal();
      });
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showAddModal() {
    this.couponModal.show();
  }

  closeAddModal() {
    this.couponModal.hide();
  }

  showConfirmModal(coupon) {
    this.currentCoupon = coupon;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }
}



// WEBPACK FOOTER //
// ./src/pages/coupon-types/coupon-types.ts